import { axios } from '@/utils/request'
import { passwordEncryption } from '@/utils/util'
import _ from 'lodash'

const api = {
  UserInfo: '/index.php/User/getInfo',
  Logout: '/index.php/User/logout',
  Login: '/index.php/User/login',
  MenuList: '/index.php/User/getMenu',
  updatePasswd: '/index.php/User/updatePasswd',
  StudentDetail: '/index.php/User/getStudentDetail',
  SaveStudent: '/index.php/User/saveStudent'
}

export function login (tenantCode, account, password, code) {
  const pwdEncrypt = passwordEncryption(password)
  return axios({
    url: api.Login,
    method: 'post',
    data: {
      tenantCode,
      account,
      code,
      password: pwdEncrypt
    }
  })
}

export function logout () {
  return axios({
    url: api.Logout,
    method: 'post'
  })
}

export function getUserInfo () {
  return axios({
    url: api.UserInfo,
    method: 'get'
  })
}

export function getUserPermission () {
  return axios({
    url: api.MenuList,
    method: 'get'
  })
    .then(res => {
      // 将权限表序列化
      if (_.get(res, 'code') === 200) {
        // return _.get(res, 'data', [])
        return _.map(_.get(res, 'data', []), res => res.auth_path)
      }
      return res
    })
}

export function updatePasswd (data) {
  return axios({
    url: api.updatePasswd,
    method: 'post',
    data: data
  })
}

export function studentDetail () {
  return axios({
    url: api.StudentDetail,
    method: 'get'
  })
}

export function saveStudent (data) {
  return axios({
    url: api.SaveStudent,
    method: 'post',
    data: data
  })
}
